import Modal from 'react-modal';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';

import { setCookie, checkCookie } from '../../../../../utils/cookies';

import {
  CookieConsentBanner,
  CookieConsentText,
  Image,
  ProdigyAgeGateMain,
  ProdigyGamePlay,
  ProdigyGamePlayLink,
  ProdigyLogo,
  ProdigyLogoMain,
  ProdigyWebsite,
  ProdigyWebsiteButton,
} from './styles';

Modal.setAppElement('body');

export default function AgeGate({ data, location }) {
  if (!data) return null;

  const {
    ctaLabelOne,
    ctaLinkOne: { url: hrefOne },
    ctaOneButtonStyle,
    ctaTextOne,
    ctaTextTwo,
    headingSectionOneHtml,
    headingSectionTwoHtml,
    imageLogo,
    imageLogoSharp,
    imageOne,
    imageOneSharp,
    imageTwo,
    imageTwoSharp,
    lang,
    microcopyTextHtml,
    sectionOneBGColourOverride,
    sectionTwoBGColourOverride,
  } = data;

  const [modalIsOpen, setIsOpen] = useState(true);
  const handleCloseModal = () => {
    setIsOpen(false);
    document.body.style.overflow = 'unset';
    setCookie('AGE_GATE', 'true', 30);
  };

  /**
   * Check & Set Age Gate cookie.
   */
  useEffect(() => {
    checkCookie('AGE_GATE=', modalIsOpen, setIsOpen);
  }, [modalIsOpen]);

  /**
   * Show/Hide Age Gate Modal.
   */
  const [showAgeGate, setShowAgeGate] = useState(false);
  useEffect(() => {
    const pagePathname = location.pathname;

    if (pagePathname === '/main-en/frank-test/') {
      setShowAgeGate(true);

      return showAgeGate;
    }

    return showAgeGate;
  }, []);

  const modalCustomStyles = {
    content: {
      backgroundColor: 'rgba(0, 0, 0, 0)',
      border: '0',
      inset: '0',
      display: 'block',
      overflow: 'auto',
      margin: '0',
      padding: '0px',
      width: '100%',
    },
    overlay: {
      alignItems: 'center',
      backdropFilter: 'blur(5px)',
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      display: 'block',
      justifyContent: 'center',
      width: '100%',
      zIndex: '78',
      overflow: 'auto',
    },
  };

  return (
    showAgeGate && (
      <Modal
        isOpen={modalIsOpen}
        contentLabel="Age Gate Modal"
        onRequestClose={handleCloseModal}
        style={modalCustomStyles}
        shouldCloseOnOverlayClick={false}
      >
        <ProdigyAgeGateMain>

          <ProdigyGamePlay
            sectionOneBGColourOverride={sectionOneBGColourOverride}
          >
            {ReactHtmlParser(headingSectionOneHtml)}
            <Image
              alt={imageOne.altTag}
              className="image-game"
              src={imageOneSharp ? imageOneSharp.publicURL : null}
            />
            <ProdigyGamePlayLink
              ariaLabel={ctaLabelOne}
              className={`${ctaOneButtonStyle} auto-size btn`}
              lang={lang}
              to={hrefOne}
            >
              {ctaTextOne}
            </ProdigyGamePlayLink>
          </ProdigyGamePlay>
          <ProdigyLogoMain>
            <ProdigyLogo
              alt={imageLogo.altTag}
              src={imageLogoSharp ? imageLogoSharp.publicURL : null}
            />
          </ProdigyLogoMain>
          <ProdigyWebsite sectionTwoBGColourOverride={sectionTwoBGColourOverride}>
            {ReactHtmlParser(headingSectionTwoHtml)}
            <Image
              alt={imageTwo.altTag}
              className="image-continue"
              src={imageTwoSharp ? imageTwoSharp.publicURL : null}
            />
            <ProdigyWebsiteButton type="button" onClick={handleCloseModal}>
              {ctaTextTwo}
            </ProdigyWebsiteButton>
          </ProdigyWebsite>
        </ProdigyAgeGateMain>
        <CookieConsentBanner>
          <CookieConsentText>
            {ReactHtmlParser(microcopyTextHtml)}
          </CookieConsentText>
        </CookieConsentBanner>
      </Modal>
    )
  );
}

AgeGate.propTypes = {
  data: PropTypes.shape().isRequired,
  location: PropTypes.shape().isRequired,
};

AgeGate.defaultProps = {};
